import request from './request'
import {RES_OK} from '@/api/config'
import {PUSH_FILTERS, SET_FILTERS, SPLICE_FILTERS} from '@/store/mutation-types'
import store from '@/store'

// 高级搜索 能搜索很多的东西

export const Brand = 'Brand' // 车型
export const Tag = 'Tag' // 精确查找
export const Activity = 'Activity' // 活动
export const Type = 'Type' // 课程类型
export const Category = 'Category' // 热门标签

export const RecommendDaka = 'RecommendDaka' // 推荐大咖，这个不属于筛选标签

function findI(arr, targetType) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i]._type === targetType) {
      return i
    }
  }
  return -1
}

function _getFilter(targetType) {
  const filter = store.getters.filters
  let i
  if ((i = findI(filter, targetType)) >= 0) {
    return filter[i]
  } else {
    return null
  }
}

// set 函数
export function pushFilter(type, obj) {
  if (typeof obj !== 'object' && typeof obj !== 'undefined') {
    console.warn('pushFilter 第二个参数必须为对象或不传')
  }
  const filter = store.getters.filters
  if (obj) {
    // 注入 _type 属性
    obj._type = type
  }
  const i = findI(filter, type)
  if (i >= 0) {
    // 有就替换
    // store.commit(SPLICE_FILTERS, i, 1, obj)
    store.commit(SPLICE_FILTERS, {
      start: i,
      length: 1,
      replace: obj
    })
  } else {
    // 没有就直接push
    store.commit(PUSH_FILTERS, obj)
  }
}

// get 函数
export function getFilter(targetType) {
  return _getFilter(targetType)
}

// 通用映射逻辑
// a, b 是拷贝参数用的，目前就拷贝一个即可
function mapHandler(targetType, handleFunc) {
  const result = {}
  if (targetType && Array.isArray(targetType)) {
    targetType.forEach(function(t) {
      result[t] = (a, b) => handleFunc(t, a, b)
    })
  } else if (typeof targetType === 'object') {
    for (let alias in targetType) {
      result[alias] = (a, b) => handleFunc(targetType[alias], a, b)
    }
  } else if (targetType) {
    result[targetType] = (a, b) => handleFunc(targetType, a, b)
  }

  return result
}

// 批量注册 get 函数
export function mapFilter(targetType) {
  return mapHandler(targetType, _getFilter)
}

// 批量注册 set 函数
export function mapPushFilter(targetType) {
  return mapHandler(targetType, pushFilter)
}

// 重置过滤条件
export function resetFilter() {
  store.commit(SET_FILTERS, [])
}

export function formatFiltersToObject() {
  const result = {}
  let r
  if ((r = _getFilter(Brand))) {
    result.brand_id = r.brand_id
    result.brand_rela_id = r.brand_rela_id
  }

  if ((r = _getFilter(Tag))) {
    result.tag_id = r.id
  }

  if ((r = _getFilter(Activity))) {
    result.activity_id = r.id
  }

  if ((r = _getFilter(Type))) {
    result.course_type = r.id
  }

  if ((r = _getFilter(Category))) {
    result.hot_cate = r.id
  }

  if ((r = _getFilter(RecommendDaka))) {
    // 推荐大咖就是 2
    result.search_type = 2
  }

  return result
}

export function mixSearch(params, page, pagesize) {
  const url = '/search/index'
  params.page = page
  params.pagesize = pagesize
  return request.get(url, {
    params
  })
}

export function getDefaultData(page) {
  const url = '/search/index'
  return request.get(url, {
    params: {
      search_type: 1,
      page: page,
      pagesize: 10
    }
  })
}

// 车型选择
// 缓存车型数据
let cacheBranchData = null
export function getBrandInfo() {
  if (cacheBranchData) {
    return Promise.resolve(cacheBranchData)
  } else {
    const url = '/search/branches'
    return request.get(url, {params: {
      size: 200
    }}).then(res => {
      const data = res.data
      if (data && data.code === RES_OK && data.data) {
        // 缓存数据
        cacheBranchData = res
      }
      return res
    })
  }
}

// 过滤标签
// 筛选页面初始化数据
export function getInitFilterData() {
  const url = '/search/precisescreen'
  return request.get(url)
}



// WEBPACK FOOTER //
// ./src/api/search.js